export default __webpack_public_path__ + "static/media/logo-white.82b71a0f.png";